import type { ReactElement } from "react";
import { Route } from "react-router-dom";
import { SettingsLayout } from "./SettingsLayout";
import { SettingsIndex } from "./SettingsIndex";
import { AppearanceSettingsPage } from "./AppearanceSettingsPage";
import { NotificationsSettingsPage } from "./NotificationsSettingsPage";
import { AccountSettingsPage } from "./AccountSettingsPage";
import { SETTINGS_ROOT } from "./settingsNav";

/**
 * The `/settings` route subtree. Returns `Route` elements for a parent
 * `<Routes>`; it is not a component. One definition serves the shell and the
 * route tests.
 */
export function settingsRoutes(): ReactElement {
    return (
        <Route path={SETTINGS_ROOT} element={<SettingsLayout />}>
            <Route index element={<SettingsIndex />} />
            <Route path="appearance" element={<AppearanceSettingsPage />} />
            <Route path="notifications" element={<NotificationsSettingsPage />} />
            <Route path="account" element={<AccountSettingsPage />} />
        </Route>
    );
}
